export const articles = [
    { id: 1, title: 'First Post', time: 'Aug 16, 2023', content: '1.md' },
]

export const myprojects = [
    {
        title: 'Document Center',
        time: 'Jun, 2025',
        course: 'NYCU CSIC30160: Cloud Native Development',
        text: "This project is a document management platform to enable secure upload, management, and auditing of technical and production documents, incorporating critical review and approval workflows.",
        link: 'https://github.com/Ray-1026/Document-Server',
        img: 'static/doc_center.png',
    },
    {
        title: 'Optimizing the Traveling Salesman Problem with Parallel Algorithms',
        time: 'Dec, 2024',
        course: 'NYCU CSIC30045: Parallel Programming',
        text: "Parallelized metaheuristic algorithms for the Traveling Salesman Problem (TSP), achieving a 37.8× speedup with under 1% loss in solution quality compared to the serial implementation.",
        link: 'https://github.com/Shukkai/Parallel-Programming-Final',
        img: 'static/pp.png',
    },
    {
        title: 'Bare metal OS',
        time: 'Mar, 2024 - Jun, 2024',
        course: 'NYCU CSIC30016: Operating Systems Capstone',
        text: 'The labs focus on designing and implementing operating system kernels on the Raspberry Pi 3, incorporating essential features such as virtual memory, virtual filesystem, context switching, timer interrupts, and process forking.',
        link: 'https://github.com/Ray-1026/osc2024/tree/110550093',
        img: 'static/github.png',
    },
    {
        title: 'CR-NeRF via Depth Guidance',
        time: 'Jun, 2024',
        course: 'NYCU CSIC30140: Computer Vision',
        text: 'Integrates monocular depth maps into NeRF for enhanced occlusion-free novel view synthesis, achieving an average 0.4 dB PSNR improvement over the ICCV 2023 SOTA method across three scenes.',
        link: 'https://github.com/Ray-1026/CR-NeRF-via-Depth-Guidance',
        img: 'static/cr_nerf.gif',
    },
    {
        title: 'Editable Video Colorization',
        time: 'Jun, 2024',
        course: 'NYCU CSCS20006: Artificial Intelligence Capstone',
        text: 'This approach simplifies the video colorization problem into a 2D image processing task while simultaneously addressing the issue of temporal consistency.',
        link: 'https://github.com/Ray-1026/AI-Capstone/tree/main/Final%20Project',
        img: 'static/aic.gif',
    },
    // {
    //     title: 'Fine-Grained Image Classifier', 
    // time: 'Jan, 2024', 
    // language: 'Python, Pytorch', 
    // text: 'This is my machine learning final project which aims to classify images into subcategories in a class. I achieved a rank of 22 out of 111 participants in the Kaggle competition.', 
    // link: 'https://github.com/Ray-1026/Intro-to-ML/tree/main/Final_Project'
    // },
    // { title: 'Reversi', 
    // time: 'Jul, 2023',
    // language: 'Python, Pygame', 
    // text: 'The game is created for the CS camp courses.  We used Pygame as the game\'s GUI and implemented AI to playagainst the player using the Mini-max algorithm.', 
    // link: 'https://github.com/Ray-1026/Reversi' },
    {
        title: 'NYCU++',
        time: 'Jan, 2023',
        course: 'NYCU CSCS10022: Introduction to Database Systems',
        text: 'A basic website designed for students to upload and search for course recommendations.',
        link: 'https://github.com/Ray-1026/DB_Project',
        img: 'static/web.png',
    },
    {
        title: 'FPS Game',
        time: 'Jan, 2023',
        course: 'NYCU CSCS10013: Introduction to Computer Graphics',
        text: 'The shooting game is my final project of introduction to computer graphics.',
        link: 'https://github.com/Ray-1026/FPS-Game',
        img: 'static/fps.png'
    },
]

export const mypublications = [
    {
        title: 'Skyfall-GS: Synthesizing Immersive 3D Urban Scenes from Satellite Imagery',
        authors: 'Jie-Ying Lee, Yi-Ruei Liu, <strong>Shr-Ruei Tsai</strong>, Wei-Cheng Chang, Chung-Ho Wu, Jiewen Chan, Zhenjun Zhao, Chieh Hubert Lin, Yu-Lun Liu',
        venue: 'ECCV 2026',
        media: { src: 'static/skyfallgs.mp4', type: 'video' },
        links: [
            { label: 'project page', url: 'https://skyfall-gs.jayinnn.dev/' },
            { label: 'arXiv', url: 'https://arxiv.org/abs/2510.15869' },
            { label: 'code', url: 'https://github.com/jayin92/skyfall-gs' },
        ],
    },
    {
        title: 'LightsOut: Diffusion-based Outpainting for Enhanced Lens Flare Removal',
        authors: '<strong>Shr-Ruei Tsai</strong>, Wei-Cheng Chang, Jie-Ying Lee, Chih-Hai Su, Yu-Lun Liu',
        venue: 'ICCV 2025',
        media: { src: 'static/LightsOut.mp4', type: 'video' },
        links: [
            { label: 'project page', url: 'https://ray-1026.github.io/lightsout/' },
            { label: 'arXiv', url: 'https://arxiv.org/abs/2510.15868' },
            { label: 'code', url: 'https://github.com/Ray-1026/LightsOut-official' },
        ],
    },
    {
        title: 'See, Point, Fly: A Learning-Free VLM Framework for Universal Unmanned Aerial Navigation',
        authors: 'Chih Yao Hu*, Yang-Sen Lin*, Yuna Lee, Chih-Hai Su, Jie-Ying Lee, <strong>Shr-Ruei Tsai</strong>, Chin-Yang Lin, Kuan-Wen Chen, Tsung-Wei Ke, Yu-Lun Liu',
        venue: 'CoRL 2025',
        media: { src: 'static/spf.mp4', type: 'video' },
        links: [
            { label: 'project page', url: 'https://spf-web.pages.dev/' },
            { label: 'arXiv', url: 'https://arxiv.org/abs/2509.22653' },
            { label: 'code', url: 'https://github.com/Hu-chih-yao/see-point-fly' },
        ],
    },
    {
        title: 'BoostMVSNeRFs: Boosting MVS-based NeRFs to Generalizable View Synthesis in Large-scale Scenes',
        authors: 'Chih-Hai Su*, Chih-Yao Hu*, <strong>Shr-Ruei Tsai*</strong>, Jie-Ying Lee*, Chin-Yang Lin, Yu-Lun Liu',
        venue: 'SIGGRAPH 2024',
        media: { src: 'static/bmn.mp4', type: 'video' },
        links: [
            { label: 'project page', url: 'https://su-terry.github.io/BoostMVSNeRFs/' },
            { label: 'arXiv', url: 'https://arxiv.org/abs/2407.15848' },
            { label: 'code', url: 'https://github.com/Su-Terry/BoostMVSNeRFs' },
        ],
    },
    {
        title: 'Predictions of Lattice Parameters in NiTi High-Entropy Shape-Memory Alloys Using Different Machine Learning Models',
        authors: 'Tu-Ngoc Lam, Jiajun Jiang, Min-Cheng Hsu, <strong>Shr-Ruei Tsai</strong>, Mao-Yuan Luo, Shuo-Ting Hsu, Wen-Jay Lee, Chung-Hao Chen, E-Wen Huang',
        venue: 'Materials 2024',
        media: { src: 'static/materials.png', type: 'image' },
        links: [
            { label: 'paper page', url: 'https://www.mdpi.com/1996-1944/17/19/4754' },
        ],
    },
]
